import React from 'react';
import { string, func } from 'prop-types';
import classnames from 'classnames/bind';

import Button from 'elements/Buttons/Button';
import Icon from 'foundations/Icons/Icon';

import styles from './TypeA.css';

const cx = classnames.bind(styles);

const TypeA = ({ className, colorScheme, icon, highlighted, title, description, button, onClick }) => (
  <section className={cx('wrapper', colorScheme, className)}>
    <div className={styles.content}>
      <Icon customClasses={styles.icon} icon={icon} type="40" />
      <h5 className={styles.title}>
        {highlighted && <span className={styles.highlight}>{highlighted}&nbsp;</span>}
        {title}
      </h5>
      <p className={styles.description}>
        {description}
      </p>
    </div>
    <Button classes={classnames('small next', styles.button)} onClick={onClick}>
      {button}
    </Button>
  </section>
);

TypeA.propTypes = {
  className: string,
  colorScheme: string,
  icon: string,
  highlighted: string,
  title: string.isRequired,
  description: string,
  button: string,
  onClick: func
};

TypeA.defaultProps = {
  colorScheme: 'lb01',
};

export default TypeA;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/SkinnyBanner/Selfcare/TypeA/TypeA.js